import { handleWindowChangeDispatch } from "@providers/chatWindow";
import {
  SideNavigationV2Props,
  type ListComponent,
} from "skedyul-ui/src/components/ui/SideNavigationV2";
import { SideNavigationComponentProps } from "../sideNavigation.schema";
import { generateContactListSchema } from "../chat.schema";

import { close as closeSidebar } from "@store/features/layout/sideNavigationSlice";
import { store } from "@store/index";
// import { getContacts } from "@store/features/chat/chatSlice";

export const sideContactListSchema = (
  args: SideNavigationComponentProps<ListComponent, { subdomain: string }>,
): SideNavigationV2Props<ListComponent> => {
  const subdomain = args.routerContext.params?.subdomain;

  const pathname = args.routerContext.pathname;
  const router = args.routerContext.router;

  const {
    chat: {
      contacts: {
        data: contacts,
        isLoading: contactsLoading,
        query: { q, limit },
      },
    },
  } = args.state;

  // get selected contact here

  // Create a page ref for the contact list
  const pageRef = {
    current: null,
  } as unknown as React.RefObject<HTMLObjectElement>;

  // Generate the contact list schema using the shared function
  const contactListProps = generateContactListSchema({
    pageRef,
    contacts,
    totalContacts: contacts.length, // This might need to be adjusted based on actual total
    cursor: { q, limit, cursorId: null },
    handleSelectChange: (contactId: string) => {
      // either open or close the chat window
      handleWindowChangeDispatch({
        view: pathname.includes("conversations") ? "hidden" : "open",
        contactId,
      });

      // if the pathname includes "conversations", close the side navigation
      if (pathname.includes("conversations")) {
        // close the side navigation
        store.dispatch(closeSidebar({ position: args.position }));
        router.push(`/${subdomain}/conversations/${contactId}`);
      }
    },
  });

  return {
    side: args.position,
    isOpen: args.state.sideNavigation[args.position].isOpen,
    width: "300px",
    component: {
      component: "List",
      props: {
        ...contactListProps,
        search: {
          ...contactListProps.search,
          value: q,
          isLoading: contactsLoading,
          type: "text" as const,
          id: contactListProps.search?.id || "search-contacts",
        },
      },
    },
  };
};
